(function($, Drupal, once) {
  'use strict';

  /**
   * Resolve issue where clear buttons
   * dont use ajaxon exposed forms using ajax
   */
  Drupal.behaviors.certSenderMortgageStep = {
    attach: function(context, settings) {
      const elements = jQuery(once('mortgage-step', '.form-wrapper[data-webform-key]', context));
      elements.each(function() {
        let $formStepWrapper = $(this);

        if ($formStepWrapper.data('webform-key') !== 'mortgage_step') {
          return;
        }

        jQuery('#paragraphsCollapse').collapse('hide');

        const $mortgageForPropertyWrapper = $('[data-drupal-selector="edit-mortgage-check-section"]');
        const $mortgagePreviousBtn = $('#mortgage-info-previous-btn');
        const $mortgageNextBtn = $('#mortgage-info-next-btn');
        const $mortgageForPopertyYes = $('[data-drupal-selector="edit-mortgage-for-property-yes"]');
        const $mortgageForPopertyNo = $('[data-drupal-selector="edit-mortgage-for-property-no"]');
        const $webformActions = $('.webform-actions');
        const $webformPreviousBtn = $webformActions.find('.webform-button--previous');
        const $webformNextBtn = $webformActions.find('.webform-button--next');

        // start as hidden if coming back from sibling step
        if ($mortgageForPopertyYes.prop('checked') || $mortgageForPopertyNo.prop('checked')) {
          $mortgageForPropertyWrapper.hide();
          $webformPreviousBtn.hide();
          $webformNextBtn.hide();
          $mortgageNextBtn.show();
          $mortgagePreviousBtn.show();
        }

        $webformNextBtn.attr('disabled', true);

        // when the button is clicked trigger hide
        // this could be done in Drupal but it was having issues firing conditional events
        $mortgageForPropertyWrapper.find('.option').on('click', function() {
          $mortgageForPropertyWrapper.hide();
          $webformPreviousBtn.hide();
          $webformNextBtn.hide();
          $mortgageNextBtn.show();
          $mortgagePreviousBtn.show();
        });

        $mortgagePreviousBtn.on('click', function(e) {
          e.preventDefault();
          // reset checkboxes with triggering a click so webform conditional events fire
          if ($mortgageForPopertyYes.prop('checked')) {
            $mortgageForPopertyYes.trigger('click');
          }
          if ($mortgageForPopertyNo.prop('checked')) {
            $mortgageForPopertyNo.trigger('click');
          }

          $mortgageForPropertyWrapper.show();
          $webformPreviousBtn.show();
          $webformNextBtn.show();
          $mortgageNextBtn.hide();
          $mortgagePreviousBtn.hide();
        });

        $mortgageNextBtn.on('click', function (e) {
          e.preventDefault();
          $webformNextBtn.trigger('click');
        });

        // Remove tid from autocomplete field and strip off address field data
        $.fn.format_mortgagee_autocomplete_field = function () {
          let field_autocomplete = jQuery('body').find('.form-autocomplete[data-drupal-selector="edit-company-name"]');
          field_autocomplete.each(function (event, node) {
            let val = $(this).val();
            let match = val.match(/\s\(.*?\)/g);
            if (match) {
              // Incoming like "Amalgamated Bank Of Chicago - One W. Monroe (52)"
              let str = val.replace(/\s\(.*?\)/g, '' )
                .replace('"', '')
                .split(' -');
              $(this).val(str[0]);
            }
          });
        };
      });
    }
  };
})(jQuery, Drupal, once);
